import { render, staticRenderFns } from "./JsonAdder.vue?vue&type=template&id=6c196cf4&"
import script from "./JsonAdder.vue?vue&type=script&lang=js&"
export * from "./JsonAdder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports